var _defs, _rect, _text, _rect2, _text2, _rect3, _text3, _rect4, _text4, _rect5, _text5, _rect6, _text6, _line, _line2, _line3, _line4, _text7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParallelApproval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 140",
    role: "img",
    "aria-label": "Parallel approval routing",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "parBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f5f3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ecfeff"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "parArrow",
    markerWidth: 8,
    markerHeight: 8,
    refX: 7,
    refY: 4,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,4 L0,8 Z",
    fill: "#7c3aed"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 140,
    rx: 8,
    fill: "url(#parBg)",
    stroke: "#c4b5fd"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 18,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#5b21b6"
  }, "Parallel routing")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 52,
    width: 72,
    height: 32,
    rx: 6,
    fill: "#fff",
    stroke: "#94a3b8"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 72,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#0f172a"
  }, "Submit")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 32,
    width: 80,
    height: 28,
    rx: 5,
    fill: "#fff",
    stroke: "#7c3aed"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 188,
    y: 50,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "#0f172a"
  }, "Approver A")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 76,
    width: 80,
    height: 28,
    rx: 5,
    fill: "#fff",
    stroke: "#7c3aed"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 188,
    y: 94,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "#0f172a"
  }, "Approver B")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 108,
    width: 80,
    height: 22,
    rx: 5,
    fill: "#fff",
    stroke: "#cbd5e1",
    strokeDasharray: "4 2"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 188,
    y: 122,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 8,
    fill: "#64748b"
  }, "&amp; more")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 52,
    width: 88,
    height: 32,
    rx: 6,
    fill: "#ede9fe",
    stroke: "#7c3aed"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 404,
    y: 72,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#0f172a"
  }, "Merge \u2192 Done")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 68,
    x2: 140,
    y2: 46,
    stroke: "#7c3aed",
    strokeWidth: 1.5,
    markerEnd: "url(#parArrow)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 68,
    x2: 140,
    y2: 90,
    stroke: "#7c3aed",
    strokeWidth: 1.5,
    markerEnd: "url(#parArrow)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 46,
    x2: 352,
    y2: 62,
    stroke: "#7c3aed",
    strokeWidth: 1.5,
    markerEnd: "url(#parArrow)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 90,
    x2: 352,
    y2: 74,
    stroke: "#7c3aed",
    strokeWidth: 1.5,
    markerEnd: "url(#parArrow)"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 132,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "#64748b"
  }, "All parallel approvers must act before the flow continues")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParallelApproval);
export default __webpack_public_path__ + "static/media/parallel-approval.b8c393fe6c5e723aa0e45db476102514.svg";
export { ForwardRef as ReactComponent };